/**
 * Created by shoulm on 09/01/2018.
 */


import {bundle, Inject, Injectable} from "ng-metadata/core";


/*This service is used in order to load the full view module during runtime*/
@Injectable()
export class FullViewModuleLoaderService{
    private fullViewDeferredObject: angular.IDeferred<any>;
    private isFullViewModuleLoaded= false;

    constructor(@Inject('$ocLazyLoad') private $ocLazyLoad: Object,
            @Inject('$q') private $q: ng.IQService){
        this.fullViewDeferredObject= this.$q.defer();
    }
    public loadFullViewModule(){
        if (!this.isFullViewModuleLoaded) {
            require.ensure(['./fullView.module'], (require) => {
                let module = require('./fullView.module');
                module= bundle(module.FullViewModule);
                this.$ocLazyLoad.inject(module.name).then(() => {
                    this.isFullViewModuleLoaded = true;
                    this.fullViewDeferredObject.resolve();
                });
            }, (error) => {
                console.log(error);
            }, 'fullView_chunk');
        }
        return this.fullViewDeferredObject.promise;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/fullViewModuleLoader.service.ts